import Vue from 'vue'
import ElementUI from 'element-ui'
import dayjs from 'dayjs'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import permissionDirective from './utils/permissionDirective'
import dialogWindow from './utils/dialogWindow'
import './assets/dialogWindow.css'

Vue.use(ElementUI)
Vue.directive('permission', permissionDirective)
Vue.directive('dialog-window', dialogWindow)
Vue.prototype.$dayjs = dayjs
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
